import {
  AgentType,
  hasEditLifecycleCapability,
  type AgentLifecycleTagSource,
} from "@superblocksteam/shared";

/**
 * Product gate shared by every UI surface advertising App Databases.
 * Server ensure/dispatch remains authoritative for per-tag enforcement.
 */
export function isManagedNativeDatabasesAvailable({
  agents,
  managedNativeDbEnabled,
  organization,
  isCloudPrem = false,
}: {
  agents?: readonly AgentLifecycleTagSource[];
  managedNativeDbEnabled: boolean;
  organization?: { agentType?: AgentType } | null;
  isCloudPrem?: boolean;
}): boolean {
  if (!managedNativeDbEnabled) {
    return false;
  }
  if (isCloudPrem) {
    return true;
  }
  if (organization?.agentType !== AgentType.ONPREMISE) {
    return false;
  }
  return hasEditLifecycleCapability(agents);
}
